import { useRef } from 'react';
import moment from 'moment';
import { interval, Subscription } from 'rxjs';
import { useStorage } from '@vivli/shared/infrastructure/hook';

export const useLogoutOnClose = () => {
    const { getItem, setItem, deleteItem } = useStorage();

    const lastActiveBrowserKey = `session_keep_alive`;
    const sessionActiveKey = `session_active`;

    const activityTimerSubRef = useRef<Subscription>(null);

    const updateLastActive = () => {
        setItem(lastActiveBrowserKey, moment().toISOString(true), 'local');
    };

    const disableTimer = () => {
        deleteItem(lastActiveBrowserKey, 'local');
        deleteItem(sessionActiveKey, 'session');
        activityTimerSubRef.current?.unsubscribe();
    };

    const checkIfLogoutNeeded = () => {
        let logoutNeeded = false;

        // If this specific tab was already active in this session, no logout needed
        const isSessionActive = getItem<boolean>(sessionActiveKey, 'session');
        if (isSessionActive) {
            return false;
        }

        // aka if all tabs were closed and this is a new tab, see if we need to start a new session / log the current user out
        const lastActiveBrowserDate = getItem<string>(lastActiveBrowserKey, 'local');
        if (lastActiveBrowserDate) {
            const currentDate = moment();
            const lastActivityDate = moment(lastActiveBrowserDate);
            const timeSinceLastActivity = currentDate.diff(lastActivityDate, 'seconds');

            if (timeSinceLastActivity > 60) {
                logoutNeeded = true;
            }
        }

        return logoutNeeded;
    };

    const initializeBrowserActivityTimer = () => {
        setItem(sessionActiveKey, true, 'session');
        updateLastActive();

        activityTimerSubRef.current?.unsubscribe();
        activityTimerSubRef.current = interval(5000).subscribe(updateLastActive);
    };

    return {
        initializeBrowserActivityTimer,
        checkIfLogoutNeeded,
        disableTimer
    };
};
